import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Utils/Button';
import { privacyConsent } from '../Core/PrivacyConsentManager';
import '../../css/PrivacyConsentModal.css';

class PrivacyConsentModal extends React.Component
{
  constructor( props )
  {
    super( props );
    this.state = {
      analyticsConsent: false,
      showDetails: false
    };
    this.handleAcceptAll = this.handleAcceptAll.bind( this );
    this.handleAcceptEssential = this.handleAcceptEssential.bind( this );
    this.handleCustomizeSettings = this.handleCustomizeSettings.bind( this );
    this.handleSaveCustom = this.handleSaveCustom.bind( this );
    this.toggleDetails = this.toggleDetails.bind( this );
    this.handleAnalyticsToggle = this.handleAnalyticsToggle.bind( this );
  }

  handleAcceptAll()
  {
    privacyConsent.setConsent( true, true );
    if( this.props.onConsentGiven )
    {
      this.props.onConsentGiven( true );
    }
  }

  handleAcceptEssential()
  {
    privacyConsent.setConsent( false, true );
    if( this.props.onConsentGiven )
    {
      this.props.onConsentGiven( false );
    }
  }

  handleCustomizeSettings()
  {
    this.setState( { showDetails: true } );
  }

  handleSaveCustom()
  {
    privacyConsent.setConsent( this.state.analyticsConsent, true );
    if( this.props.onConsentGiven )
    {
      this.props.onConsentGiven( this.state.analyticsConsent );
    }
  }

  toggleDetails()
  {
    this.setState( prevState => ( { showDetails: !prevState.showDetails } ) );
  }

  handleAnalyticsToggle()
  {
    this.setState( prevState => ( { analyticsConsent: !prevState.analyticsConsent } ) );
  }

  render()
  {
    const { show } = this.props;
    const { showDetails, analyticsConsent } = this.state;

    return (
      <Modal
        show={ show }
        centered
        className="modal-popup privacy-consent-modal"
        size="lg"
        backdrop="static"
        keyboard={ false }
      >
        <Modal.Header>
          <Modal.Title className="modal-popup-title">
            🍪 Privacy & Cookies
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="privacy-consent-content">
            <div className="privacy-intro">
              <p>
                We care about your privacy. Tilefolk.io uses cookies and analytics to improve your gaming experience
                and help us understand how players use our game.
              </p>
            </div>

            { !showDetails && (
              <div className="privacy-summary">
                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <strong>✅ Essential Cookies</strong>
                    <span className="cookie-status required">Required</span>
                  </div>
                  <p className="cookie-description">
                    Necessary for the website to function properly. These include authentication,
                    game state, and security features.
                  </p>
                </div>

                <div className="cookie-category">
                  <div className="cookie-category-header">
                    <strong>📊 Analytics Cookies</strong>
                    <span className="cookie-status optional">Optional</span>
                  </div>
                  <p className="cookie-description">
                    Help us understand how you use Tilefolk.io so we can improve the game.
                    This includes gameplay statistics and feature usage.
                  </p>
                </div>

                <div className="privacy-links">
                  <button
                    type="button"
                    className="link-button"
                    onClick={ this.toggleDetails }
                  >
                    View detailed settings
                  </button>
                  { ' • ' }
                  <a href="/privacy" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </a>
                </div>
              </div>
            ) }

            { showDetails && (
              <div className="privacy-details">
                <div className="cookie-category detailed">
                  <div className="cookie-category-header">
                    <strong>Essential Cookies</strong>
                    <span className="cookie-toggle">
                      <input
                        type="checkbox"
                        checked={ true }
                        disabled={ true }
                        id="essential-cookies"
                      />
                      <label htmlFor="essential-cookies">Always Active</label>
                    </span>
                  </div>
                  <p className="cookie-description">
                    These cookies are necessary for the website to function and cannot be switched off.
                    They include: authentication tokens, game session data, security preferences, and
                    accessibility settings.
                  </p>
                </div>

                <div className="cookie-category detailed">
                  <div className="cookie-category-header">
                    <strong>Analytics & Performance</strong>
                    <span className="cookie-toggle">
                      <input
                        type="checkbox"
                        checked={ analyticsConsent }
                        onChange={ this.handleAnalyticsToggle }
                        id="analytics-cookies"
                      />
                      <label htmlFor="analytics-cookies">
                        { analyticsConsent ? 'Enabled' : 'Disabled' }
                      </label>
                    </span>
                  </div>
                  <p className="cookie-description">
                    These cookies help us analyze how players use Tilefolk.io, including: game completion rates,
                    feature usage, performance metrics, and error tracking. This data is anonymized and helps
                    us improve the game experience.
                    <br />
                    <small>
                      <strong>Data collected:</strong> Game events, page views, feature interactions, error logs
                      <br />
                      <strong>Third-party services:</strong> Amplitude Analytics (EU servers)
                    </small>
                  </p>
                </div>

                <div className="privacy-links">
                  <button
                    type="button"
                    className="link-button"
                    onClick={ this.toggleDetails }
                  >
                    ← Back to simple view
                  </button>
                  { ' • ' }
                  <a href="/privacy" target="_blank" rel="noopener noreferrer">
                    Full Privacy Policy
                  </a>
                </div>
              </div>
            ) }

            <div className="privacy-footer">
              <p>
                <small>
                  You can change these preferences at any time in your account settings.
                  By continuing to use Tilefolk.io, you agree to our use of essential cookies.
                </small>
              </p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="privacy-consent-buttons">
            { !showDetails ? (
              <>
                {/* <Button
                  variant="secondary"
                  onClick={ this.handleAcceptEssential }
                  style={ { marginRight: '10px' } }
                >
                  Essential Only
                </Button> */}
                <Button
                  variant="outline"
                  className="button-fixed-width"
                  onClick={ this.handleCustomizeSettings }
                  style={ { marginRight: '10px' } }
                >
                  Manage Options
                </Button>
                <Button
                  variant="primary"
                  className="button-fixed-width"
                  onClick={ this.handleAcceptAll }
                >
                  Consent
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="secondary"
                  className="button-fixed-width"
                  onClick={ this.handleAcceptAll }
                  style={ { marginRight: '10px' } }
                >
                  Accept All
                </Button>
                <Button
                  variant="primary"
                  className="button-fixed-width"
                  onClick={ this.handleSaveCustom }
                >
                  Confirm Choices
                </Button>
              </>
            ) }
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PrivacyConsentModal;
